<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="1" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container2 v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container2>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container2 from '@/components/Container2.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        video:{
          title:'國人十大癌症 頭頸癌',
          videosrc:'R05.mp4',
          list:[
            {

              title:'放射治療流程',
              body:"透過精準的儀器設備以多角度的治療方式，遵循醫師及相關工作人員的指示，提供您在治療過程能準確的將放射線打擊在腫瘤上，以期達到治癒的目的。整體治療流程的說明，讓病患能安心地且充滿信心地完成治療。"

            }

          ]
        },
        text:{
          title:'國人十大癌症 － 頭頸癌',
          videobtnname:'治療流程',
          videoImg:'R05v.png',
          list:[
            {

              title:'頭頸癌是什麼？',
              body:"是指位於頭頸部位，除了腦癌以外的其他惡性腫瘤。頭頸癌的常見部份包括口腔、鼻、喉嚨、鼻竇、唾液腺、喉頭等。頭頸癌的症狀包括有無法醫好的瘡或是硬塊、持續出現的喉嚨痛、吞嚥困難或是聲音的變化，若是有異常出血、面部腫脹、呼吸困難，也有可能是頭頸癌。"

            },
            {

              title:'如何治療頭頸癌？',
              body:"治療方法主要有手術切除、放療、化療、標靶治療或合併採用上述療法。彼此相輔相成，方法的選擇要看組織病理學上的診斷，腫瘤的生長位置及大小，有無頸部淋巴節轉移，有無遠端轉移、對化學藥物及放射線治療的敏感性，病患的身體狀況及醫師的經驗等。原則上早期病變以手術切除為主，晚期或有頸部轉移病患以手術切除併頸部淋巴廓清術和術後放射線或化療為主。"

            },
            {

              title:'頭頸癌放射治療的原因和時機？',
              body:"若是以放射線治療作為根治之主要治療模式，進行口咽癌、喉癌、下咽癌等器官保留。若是以放射線作為手術後之輔助治療，主要是針對術後還具有危險因子者。"

            },
          ]
        }
      },

    }
  },
  components: {
    Back,Container2,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
